const emptyReducer = (state = {}) => state;

export { emptyReducer as cv };
export { emptyReducer as user_info };
export { emptyReducer as authors };
export { emptyReducer as works };
export { emptyReducer as sections };
export { emptyReducer as social_links };
export { emptyReducer as current_user };
export { emptyReducer as videos };
export { emptyReducer as courses };
